import { useEffect } from "react";
import { useNavigationType } from "react-router-dom";

// Remembers how far a page was scrolled and puts the page back there when the user returns with Back (for example from
// a Sound Detail page to Fan Home). Sections load one by one, so the restore waits until the page is tall enough.
const KEY = "pipaan.scroll.";
const read = (name) => { try { return Number(sessionStorage.getItem(KEY + name)) || 0; } catch (e) { return 0; } };
const write = (name, y) => { try { sessionStorage.setItem(KEY + name, String(Math.round(y))); } catch (e) { /* storage unavailable: nothing is remembered */ } };

export function useScrollMemory(name) {
  const navigationType = useNavigationType();

  useEffect(() => {
    const previous = window.history.scrollRestoration;
    try { window.history.scrollRestoration = "manual"; } catch (e) { /* not supported */ }

    let restoring = navigationType === "POP" && read(name) > 0;
    let userMoved = false;
    const target = read(name);
    const stopRestoring = () => { restoring = false; userMoved = true; };
    const onScroll = () => { if (!restoring || userMoved) write(name, window.scrollY); };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("wheel", stopRestoring, { passive: true });
    window.addEventListener("touchmove", stopRestoring, { passive: true });

    let timer;
    const startedAt = Date.now();
    const tryRestore = () => {
      if (!restoring) return;
      const maxY = document.documentElement.scrollHeight - window.innerHeight;
      if (maxY >= target || Date.now() - startedAt > 4000) {
        window.scrollTo(0, Math.min(target, Math.max(0, maxY)));
        restoring = false;
        return;
      }
      timer = setTimeout(tryRestore, 100);
    };
    if (restoring) tryRestore();
    else if (navigationType !== "POP") write(name, 0);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("wheel", stopRestoring);
      window.removeEventListener("touchmove", stopRestoring);
      try { window.history.scrollRestoration = previous || "auto"; } catch (e) { /* not supported */ }
    };
  }, [name, navigationType]);
}
